var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertaiIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "95.91 457.15 889.12 165.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #141b8f;\n      }\n\n      .cls-3 {\n        fill: #007be0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M256.34,619.2s-88.06,17.87-131.35-25.43c-43.29-43.29-25.43-131.35-25.43-131.35,0,0,88.06-17.87,131.35,25.43,43.29,43.29,25.43,131.35,25.43,131.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.79,581.13c-34.18,0-61.99-27.81-61.99-61.99s27.81-61.99,61.99-61.99,61.99,27.81,61.99,61.99-27.81,61.99-61.99,61.99ZM199.79,479.28c-21.98,0-39.86,17.88-39.86,39.86s17.88,39.86,39.86,39.86,39.86-17.88,39.86-39.86-17.88-39.86-39.86-39.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 199.79,
    cy: 519.14,
    r: 22.32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444.77,561.54v51.86h-25.1v-10.04c-5.02,6.48-15.68,11.92-30.95,11.92-30.32,0-52.07-21.75-52.07-54.16s21.75-53.75,53.95-53.75,54.16,21.75,54.16,54.16ZM390.81,530.38c-17.57,0-29.07,11.5-29.07,30.95s11.5,30.95,29.07,30.95,28.86-11.5,28.86-30.95-11.5-30.95-28.86-30.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467.43,467.01h25.1v146.39h-25.1v-146.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M589.06,580.99h27.4c-6.9,21.12-25.51,34.3-50.82,34.3-32.41,0-54.16-21.75-54.16-54.16s21.75-53.75,54.16-53.75,53.95,21.54,53.95,53.75c0,2.93-.21,5.65-.42,8.37h-81.77c2.72,14.43,13.18,22.79,28.02,22.79,10.46,0,18.61-3.97,23.63-11.29ZM591.78,546.48c-4.39-10.25-13.8-16.1-26.35-16.1s-21.75,5.86-26.14,16.1h52.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M689.17,506.96v23c-16.73,0-26.77,8.16-26.77,24.89v58.56h-25.1v-58.56c0-31.79,20.08-47.89,51.86-47.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M757.32,614.87c-34.3,0-52.49-17.36-52.49-49.56v-98.29h25.1v41.83h23.84v23h-23.84v33.25c0,19.03,7.74,26.77,27.4,26.77v23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M936.75,561.54v51.86h-25.1v-10.04c-5.02,6.48-15.68,11.92-30.95,11.92-30.32,0-52.07-21.75-52.07-54.16s21.75-53.75,53.95-53.75,54.16,21.75,54.16,54.16ZM882.79,530.38c-17.57,0-29.07,11.5-29.07,30.95s11.5,30.95,29.07,30.95,28.86-11.5,28.86-30.95-11.5-30.95-28.86-30.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M971.23,464.71c7.74,0,13.8,6.27,13.8,13.8,0,7.95-6.06,14.01-13.8,14.01s-13.8-6.06-13.8-14.01c0-7.53,6.06-13.8,13.8-13.8ZM958.68,508.84h25.1v104.56h-25.1v-104.56Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaiIconLight);
export default __webpack_public_path__ + "static/media/alertai_icon_light.4f8dc2a4ccd37c9ba4ace5a483be3e15.svg";
export { ForwardRef as ReactComponent };